"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.range"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WizardNavigation = function WizardNavigation(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      _ref$footer = _ref.footer,
      footer = _ref$footer === void 0 ? null : _ref$footer;
  var style = (0, _classnames.default)({
    'co-wizard__placeholder': loading
  });
  return _react.default.createElement("nav", {
    className: style
  }, _react.default.createElement("ul", null, loading ? (0, _lodash.default)(3).map(function (index) {
    return _react.default.createElement(WizardNavLoadingItem, {
      key: index
    });
  }) : children), loading ? null : footer);
};

var WizardNavLoadingItem = function WizardNavLoadingItem() {
  return _react.default.createElement("li", null);
};

WizardNavigation.propTypes = {
  children: _propTypes.default.node,
  footer: _propTypes.default.node,
  loading: _propTypes.default.bool
};
var _default = WizardNavigation;
exports.default = _default;
WizardNavigation.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "WizardNavigation",
  "props": {
    "footer": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "loading": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};